import React from 'react';
import NewsCard from './newsCard/NewsCard';

import "./RightSection.css";
const RightSection = () => {
    return (
        <div className="rightSection">
            <NewsCard />
        </div>
    )
}

export default RightSection;